"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const aws_common_1 = require("@biorad-lsg-tsc/aws-common");
const status_codes_1 = require("@biorad-lsg-tsc/status-codes");
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
const http_status_codes_1 = require("http-status-codes");
const user_permissions_1 = __importDefault(require("./user-permissions"));
class TokenValidation {
    static async validatePermissionsInHeaders(permissions, headers, userId, tenantId) {
        await TokenValidation.validateToken(user_permissions_1.default.extractHeaderAccessToken(headers));
        const userPermissions = await user_permissions_1.default.getUserPermissions(headers);
        const userCognitoId = userPermissions?.userCognitoId;
        if (!TokenValidation.validateRequestUserIdInToken(userCognitoId, userId))
            throw new status_codes_1.StatusCodeError(http_status_codes_1.StatusCodes.UNAUTHORIZED, `user ${userId} is unauthorized`);
        await TokenValidation.validatePermissions(permissions, userPermissions, tenantId);
    }
    static validateRequestUserIdInToken(userCognitoId, userId) {
        if (userCognitoId && userId)
            return userCognitoId === userId;
        return false;
    }
    static async validateRequestTenantInToken(tenantId, userPermissions) {
        const accessTokenTenantId = userPermissions.tenantId;
        if (accessTokenTenantId !== tenantId) {
            console.log(`validateTenantToken ERROR: TenantId in token: ${accessTokenTenantId}, TenantId in request: ${tenantId}`);
            throw new status_codes_1.BadRequestError(`TenantId in header does not match the request`);
        }
    }
    static async validatePermissions(permissions, userPermissions, tenantId) {
        await TokenValidation.validateRequestTenantInToken(tenantId, userPermissions);
        if (!userPermissions.hasPermissions(permissions)) {
            console.log(`User ${userPermissions.id} does not have permissions. ${JSON.stringify(permissions)}`);
            throw new status_codes_1.StatusCodeError(http_status_codes_1.StatusCodes.FORBIDDEN, 'insufficient permissions');
        }
    }
    static async validateToken(userToken) {
        const secretsManager = new aws_common_1.SecretsManager();
        const { SecretString } = await secretsManager.getSecret('frontegg-auth');
        let { [`jwt-signature-${TokenValidation.getEnv()}`]: jwtSignature } = JSON.parse(SecretString);
        console.log(`validateToken. jwtSignature=${jwtSignature}`);
        jwtSignature = jwtSignature.split('*****').join('\n');
        console.log(`validateToken. fixed jwtSignature=${jwtSignature}`);
        try {
            return jsonwebtoken_1.default.verify(userToken, jwtSignature);
        }
        catch (ex) {
            console.log(`validateToken. Error: ${ex}`);
            if (ex instanceof jsonwebtoken_1.default.TokenExpiredError)
                throw new status_codes_1.StatusCodeError(http_status_codes_1.StatusCodes.UNAUTHORIZED, 'Token expired');
            throw ex;
        }
    }
    static getEnv() {
        const baseDomain = process.env.BASE_DOMAIN;
        switch (baseDomain) {
            case 'brlabcloud.cloud':
                return 'lab';
            case 'brcloud.cloud':
                return 'dev';
            case 'br.io':
                return 'prod';
            default:
                return 'prod';
        }
    }
}
exports.default = TokenValidation;
